import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FiInfo } from 'react-icons/fi';
import { ADMIN_ROLES_WITH_DETAILS } from '../../constants/adminRoles';
import { normalizeAdminUserRole } from '../../constants/app';
import RoleDetailsModal from './RoleDetailsModal';

/** Bouton « Détails des rôles » : ouvre une modal unique, positionnée sur le rôle sélectionné (ou le premier). */
const RoleDetailsButton = ({ selectedRole, className }) => {
    const [show, setShow] = useState(false);
    const [role, setRole] = useState(null);

    const handleOpen = () => {
        setRole(normalizeAdminUserRole(selectedRole) || ADMIN_ROLES_WITH_DETAILS[0].value);
        setShow(true);
    };

    return (
        <>
            <Button
                type="button"
                variant="outline-primary"
                className={className}
                onClick={handleOpen}
                aria-haspopup="dialog"
            >
                <FiInfo className="me-2" aria-hidden="true" />
                Détails des rôles
            </Button>

            <RoleDetailsModal
                show={show}
                role={role}
                onHide={() => setShow(false)}
                onRoleChange={setRole}
            />
        </>
    );
};

export default RoleDetailsButton;
